import React, {useEffect, useState, memo} from 'react';
import ConfirmPopup from './ConfirmPopup.js';
import post from '../utils/post.js';

function ExerciseWorkoutRec({item, rec, index2, sOrder, today, setData, targetUsrId, applyTargetUsrMeta}) {
	const [idForDelete, setIdForDelete] = useState(0);
	const [showConfirmPopup, setShowConfirmPopup] = useState(false);
	const [now, setNow] = useState(new Date().getDate() + '.' + (new Date().getMonth() + 1) + '.' + new Date().getFullYear());
	const [isEditing, setIsEditing] = useState(false);
	const [weights, setWeights] = useState({});
	const [cnt, setCnt] = useState({});
	const [seconds, setSeconds] = useState({});
	const [minutes, setMinutes] = useState({});

	useEffect(() => {
		const nextWeights = {};
		const nextCnt = {};
		const nextSeconds = {};
		const nextMinutes = {};

		item.recs.forEach((itemRec) => {
			nextWeights['LIST_EXERCISE_REC_EDIT_WEIGHT_' + itemRec.ID] = itemRec.WEIGHT;
			nextCnt['LIST_EXERCISE_REC_EDIT_CNT_' + itemRec.ID] = itemRec.CNT;
			nextMinutes['LIST_EXERCISE_REC_EDIT_M_' + itemRec.ID] = itemRec.TIMESEC_M;
			nextSeconds['LIST_EXERCISE_REC_EDIT_S_' + itemRec.ID] = itemRec.TIMESEC_S;
		});

		setNow(new Date().getDate() + '.' + (new Date().getMonth() + 1) + '.' + new Date().getFullYear());
		setWeights(nextWeights);
		setCnt(nextCnt);
		setMinutes(nextMinutes);
		setSeconds(nextSeconds);
		setIsEditing(false);
	}, [item.recs, rec]);

	const handleConfirmPopup = (id) => {
		setIdForDelete(id);
		setShowConfirmPopup(true);
	};

	const closeConfirmPopup = () => {
		setShowConfirmPopup(false);
	};

	const deleteConfirmPopup = () => {
		const payload = {DT: today, ID: idForDelete};

		if (targetUsrId > 0) {
			payload.USRID = targetUsrId;
		}

		post('deleteExerciseWorkout', payload)
			.then((res) => {
				setData(res.data);
				applyTargetUsrMeta(res.data);
				closeConfirmPopup();
			})
			.catch((error) => {
				console.error(error);
				closeConfirmPopup();
			});
	};

	const handleEdit = () => {
		setIsEditing((prevIsEditing) => !prevIsEditing);
	};

	const handleEditSave = (id, typeId) => {
		let cntValue = 0;
		let weightValue = 0;
		let minuteValue = 0;
		let secondValue = 0;

		if (typeId === 1) {
			cntValue = cnt['LIST_EXERCISE_REC_EDIT_CNT_' + id];
			weightValue = weights['LIST_EXERCISE_REC_EDIT_WEIGHT_' + id];
		}

		if (typeId === 2) {
			minuteValue = minutes['LIST_EXERCISE_REC_EDIT_M_' + id];
			secondValue = seconds['LIST_EXERCISE_REC_EDIT_S_' + id];
		}

		const payload = {DT: today, ID: id, CNT: cntValue, WEIGHT: weightValue, TIMESEC_M: minuteValue, TIMESEC_S: secondValue};

		if (targetUsrId > 0) {
			payload.USRID = targetUsrId;
		}

		post('saveExerciseWorkoutOld', payload)
			.then((res) => {
				setIsEditing(false);
				setData(res.data);
				applyTargetUsrMeta(res.data);
			})
			.catch((error) => {
				console.error(error);
			});
	};

	const isEditable = now === today;
	const recordLabel = item.TYPEID === 1 ? `${rec.CNT} x ${rec.WEIGHT} kg` : rec.TIMESECS;

	return (
		<>
			<ConfirmPopup showConfirmPopup={showConfirmPopup} showButtonDelete deleteConfirmPopup={deleteConfirmPopup} closeConfirmPopup={closeConfirmPopup} infoHeader="Smazání záznamu" infoMain="Opravdu chceš smazat tento záznam?" />
			<div key={'workouteRec_' + index2} className="exercise-page__record">
				<div className={`exercise-page__record-main${isEditing ? ' exercise-page__record-main--editing' : ''}`}>
					<div className="exercise-page__record-summary">
						<div className="exercise-page__record-meta">
							<div className="exercise-page__record-date">
								{sOrder}. {rec.CRDT_TMS}
							</div>
						</div>

						{!isEditing ? (
							<div style={{alignItems: 'center', display: 'flex', gap: '0.55rem', marginLeft: 'auto', minWidth: 0}}>
								<div className="exercise-page__record-value" style={{textAlign: 'right'}}>{recordLabel}</div>
								{isEditable ? (
									<div className="exercise-page__record-actions">
										<button type="button" className="exercise-page__record-action" onClick={handleEdit} aria-label={isEditing ? 'Zrušit úpravu záznamu' : 'Upravit záznam'}>
											<img className="icon1 edit" alt="" />
										</button>
										<button type="button" className="exercise-page__record-action exercise-page__record-action--danger" onClick={() => handleConfirmPopup(rec.ID)} aria-label="Smazat záznam">
											<img className="icon1 del" alt="" />
										</button>
									</div>
								) : (
									''
								)}
							</div>
						) : (
							''
						)}
					</div>

					{isEditable && isEditing ? (
						<div className="exercise-page__record-edit">
							{item.TYPEID === 1 ? (
								<>
									<button type="button" className="exercise-page__record-save" onClick={() => handleEditSave(rec.ID, 1)}>
										<img className="icon1 ok1" alt="" />
									</button>
									<span className="exercise-page__record-inline-label">kg</span>
									<div className="exercise-page__record-input-wrap">
										<input
											className="input-text exercise-page__record-input"
											id={'LIST_EXERCISE_REC_EDIT_WEIGHT_' + rec.ID}
											type="number"
											step={0.01}
											maxLength={5}
											value={weights['LIST_EXERCISE_REC_EDIT_WEIGHT_' + rec.ID] || ''}
											onChange={(e) =>
												setWeights({
													...weights,
													['LIST_EXERCISE_REC_EDIT_WEIGHT_' + rec.ID]: e.target.value,
												})
											}
										/>
									</div>
									<span className="exercise-page__record-inline-label">x</span>
									<div className="exercise-page__record-input-wrap">
										<input
											className="input-text exercise-page__record-input"
											id={'LIST_EXERCISE_REC_EDIT_CNT_' + rec.ID}
											type="number"
											maxLength={3}
											value={cnt['LIST_EXERCISE_REC_EDIT_CNT_' + rec.ID] || ''}
											onChange={(e) =>
												setCnt({
													...cnt,
													['LIST_EXERCISE_REC_EDIT_CNT_' + rec.ID]: e.target.value,
												})
											}
										/>
									</div>
								</>
							) : (
								<>
									<button type="button" className="exercise-page__record-save" onClick={() => handleEditSave(rec.ID, 2)}>
										<img className="icon1 ok1" alt="" />
									</button>
									<div className="exercise-page__record-input-wrap">
										<input
											className="input-text exercise-page__record-input"
											id={'LIST_EXERCISE_REC_EDIT_S_' + rec.ID}
											type="number"
											maxLength={2}
											value={seconds['LIST_EXERCISE_REC_EDIT_S_' + rec.ID] || ''}
											onChange={(e) =>
												setSeconds({
													...seconds,
													['LIST_EXERCISE_REC_EDIT_S_' + rec.ID]: e.target.value,
												})
											}
										/>
									</div>
									<span className="exercise-page__record-inline-label">:</span>
									<div className="exercise-page__record-input-wrap">
										<input
											className="input-text exercise-page__record-input"
											id={'LIST_EXERCISE_REC_EDIT_M_' + rec.ID}
											type="number"
											maxLength={3}
											value={minutes['LIST_EXERCISE_REC_EDIT_M_' + rec.ID] || ''}
											onChange={(e) =>
												setMinutes({
													...minutes,
													['LIST_EXERCISE_REC_EDIT_M_' + rec.ID]: e.target.value,
												})
											}
										/>
									</div>
								</>
							)}
						</div>
					) : (
						''
					)}
				</div>
			</div>
		</>
	);
}

export default memo(ExerciseWorkoutRec);
